import { Component, Input, OnChanges } from '@angular/core';
import { Select } from '@ngxs/store';
import { SessionState } from '@platform-frontend/account';
import { Asset } from '@platform-frontend/marketplace';
import { TypedChanges } from '@platform-frontend/util';
import { Observable } from 'rxjs';

@Component({
  selector: 'yat-confirmation-vendor-instructions',
  templateUrl: './confirmation-vendor-instructions.component.html',
  styleUrls: ['./confirmation-vendor-instructions.component.scss']
})
export class ConfirmationVendorInstructionsComponent implements OnChanges {
  @Input()
  asset: Asset | null = null;

  @Select(SessionState.accountLinked)
  accountLinked$: Observable<boolean>;

  faqLink: string | null = null;

  ngOnChanges(changes: TypedChanges<ConfirmationVendorInstructionsComponent>): void {
    if (changes.asset) {
      this.faqLink = this.asset?.product.productPaths.find(path => path.type === 'DOCUMENTATION')?.url ?? null;
    }
  }
}
